import React, { useState } from 'react';

const NecrovaHiring = () => {
  const [jobs, setJobs] = useState([
    {
      id: 1,
      title: 'ERR0R',
      department: 'ERR0R',
      description: 'ERR0R',
      requirements: [
        'ERR0R',
        
      ]
    },
   
  ]);

  return (
    <div className="necrova-hiring-container">
      <div className="hiring-card">
        <div className="hiring-header">
          <div className="logo-container">
            <img 
              src="https://cdn.4fingerstudios.com/Necrova/NecrovaStuffas/Full.png" 
              width="60" 
              height="60" 
              alt="Necrova Logo"
            />
            <h1 className="company-title">NECROVA</h1>
          </div>
          <h2 className="hiring-title">Career Opportunities</h2>
        </div>

        <div className="job-listings">
          {jobs.map((job) => (
            <div key={job.id} className="job-card">
              <div className="job-header">
                <h3 className="job-title">{job.title}</h3>
                <span className="job-department">{job.department}</span>
              </div>
              <p className="job-description">{job.description}</p>
              <div className="job-requirements">
                <h4>Requirements:</h4>
                <ul>
                  {job.requirements.map((req, index) => (
                    <li key={index}>{req}</li>
                  ))}
                </ul>
              </div>
              <button className="apply-button">Apply Now</button>
            </div>
          ))}
        </div>

        <div className="hiring-footer">
          <p className="footer-text">NECROVA INDUSTRIES • EQUAL OPPORTUNITY EMPLOYER</p>
          <p className="system-info">HIRING PORTAL V1.2.3 • {new Date().getFullYear()}</p>
        </div>
      </div>

      <div className="decorative-elements">
        <div className="moving-particles"></div>
        <div className="circuit-lines"></div>
      </div>

      <style jsx>{`
        .necrova-hiring-container {
          font-family: 'Arial', sans-serif;
          margin: 0;
          padding: 0;
          color: white;
          background: linear-gradient(135deg, #0f0f1a 0%, #1a1a2e 50%, #16213e 100%);
          min-height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          overflow: hidden;
        }

        .hiring-card {
          background-color: rgba(15, 15, 26, 0.8);
          border-radius: 10px;
          border: 1px solid rgba(138, 43, 226, 0.3);
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);
          width: 90%;
          max-width: 1000px;
          padding: 2rem;
          backdrop-filter: blur(5px);
          position: relative;
          z-index: 10;
        }

        .hiring-header {
          text-align: center;
          margin-bottom: 2rem;
        }

        .logo-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 1rem;
        }

        .company-title {
          font-size: 2rem;
          font-weight: bold;
          letter-spacing: 3px;
          margin: 0.5rem 0;
          color: white;
        }

        .hiring-title {
          font-size: 1.2rem;
          color: #e94560;
          font-weight: normal;
          letter-spacing: 1px;
          position: relative;
          display: inline-block;
        }

        .hiring-title::after {
          content: '';
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 50px;
          height: 2px;
          background: linear-gradient(90deg, #8a2be2, #e94560);
        }

        .job-listings {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 1.5rem;
          margin-bottom: 2rem;
        }

        .job-card {
          background-color: rgba(26, 26, 46, 0.5);
          border: 1px solid rgba(138, 43, 226, 0.3);
          border-radius: 8px;
          padding: 1.5rem;
          transition: all 0.3s ease;
        }

        .job-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 5px 15px rgba(138, 43, 226, 0.2);
        }

        .job-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 1rem;
        }

        .job-title {
          font-size: 1.2rem;
          color: #8a2be2;
          margin: 0;
        }

        .job-department {
          font-size: 0.8rem;
          color: #e94560;
          background-color: rgba(233, 69, 96, 0.1);
          padding: 0.3rem 0.6rem;
          border-radius: 4px;
        }

        .job-description {
          color: #8a8aaa;
          margin-bottom: 1rem;
        }

        .job-requirements h4 {
          color: #8a2be2;
          margin-bottom: 0.5rem;
        }

        .job-requirements ul {
          list-style-type: none;
          padding: 0;
          margin: 0;
        }

        .job-requirements li {
          color: #8a8aaa;
          padding: 0.3rem 0;
          position: relative;
          padding-left: 1.5rem;
        }

        .job-requirements li::before {
          content: '•';
          position: absolute;
          left: 0;
          color: #e94560;
        }

        .apply-button {
          width: 100%;
          padding: 0.8rem;
          background: linear-gradient(90deg, #8a2be2, #e94560);
          border: none;
          color: white;
          border-radius: 4px;
          cursor: pointer;
          transition: all 0.3s ease;
          margin-top: 1rem;
        }

        .apply-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 8px rgba(138, 43, 226, 0.5);
        }

        .hiring-footer {
          text-align: center;
          border-top: 1px solid rgba(138, 43, 226, 0.3);
          padding-top: 1rem;
        }

        .footer-text {
          font-size: 0.8rem;
          color: #8a8aaa;
          margin-bottom: 0.5rem;
        }

        .system-info {
          font-size: 0.7rem;
          color: #8a8aaa;
          letter-spacing: 1px;
        }

        .decorative-elements {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          overflow: hidden;
          z-index: 1;
        }

        /* Most of the decorative animations and elements are the same as in the Login page */
        .moving-particles::before,
        .moving-particles::after {
          content: '';
          position: absolute;
          background-color: rgba(138, 43, 226, 0.1);
          border-radius: 50%;
        }

        .moving-particles::before {
          width: 200px;
          height: 200px;
          top: -100px;
          right: -50px;
          animation: moveParticle1 15s infinite alternate;
        }

        .moving-particles::after {
          width: 300px;
          height: 300px;
          bottom: -150px;
          left: -100px;
          animation: moveParticle2 20s infinite alternate;
        }

        .circuit-lines::before,
        .circuit-lines::after {
          content: '';
          position: absolute;
          background: linear-gradient(90deg, transparent, rgba(138, 43, 226, 0.1), transparent);
          height: 1px;
        }

        @media (max-width: 600px) {
          .hiring-card {
            padding: 1rem;
          }

          .job-listings {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </div>
  );
};

export default NecrovaHiring;